import { DNDMetaContext, type DNDMetaContextI } from '@components/dnd/base';
import DropZone from '@components/dnd/base/DropZone';
import { DNDBlockRender } from '@library';
import type { DNDBlock } from '@stratumn/studio-shared';
import { useContext } from 'react';

type InteractionZoneProps = {
  dndBlock: DNDBlock | DNDBlock[];
  path: string;
  isLast?: boolean;
};

export const InteractionZone = ({
  dndBlock,
  path,
  isLast
}: InteractionZoneProps) => {
  const library = useContext<DNDMetaContextI>(DNDMetaContext).library;

  if (Object.keys(dndBlock).length > 0) {
    return (
      <DNDBlockRender
        block={dndBlock}
        isLast={isLast}
        library={library}
        path={path}
      />
    );
  }

  const generate_path = (path: string) => {
    if (path.includes('|')) {
      return path;
    }
    return `${path}|0`;
  };

  return <DropZone data={{ path: generate_path(path) }} isLast={isLast} />;
};
